// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import cx from 'classnames'
import React from 'react'
import { Mutation } from 'react-apollo'
import type { RouterHistory } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import { i18n } from '../index'
import css from './monthlyInfoPage.css'
import { upsertMonthlyInfo } from './monthlyInfoQueries'
import type { SubjectType } from './monthlyInfoTypes'

type RequiresActionProps = {
  history: RouterHistory
  stationId: string
  date: string
  monthlyInfoId?: string
  subject: SubjectType
  isActionRequired?: boolean | null
  showCreateTaskButton?: boolean
  callback?: (...args: Array<any>) => any
  refetch?: (...args: Array<any>) => any
}

type RequiresActionState = {
  isActionRequired: boolean
}

class RequiresAction extends React.PureComponent<RequiresActionProps, RequiresActionState> {
  state = {
    isActionRequired: '',
  }

  componentDidMount() {
    if (this.props.isActionRequired !== null) {
      this.setState({
        isActionRequired: this.props.isActionRequired ? 'yes' : 'no',
      })
    }
  }

  onChange = async (onMutate: (...args: Array<any>) => any, radioState: string) => {
    if (radioState === '') return
    this.setState({
      isActionRequired: radioState,
    })
    const { stationId, date, monthlyInfoId: id, callback, refetch } = this.props

    if (callback) {
      callback()
    } else {
      const required = radioState === 'yes'

      await onMutate({
        variables: {
          stationId,
          date,
          monthlyInfo: {
            id,
            isActionRequired: required,
          },
        },
      })

      if (refetch) {
        refetch()
      }
    }
  }

  onCreateTask = () => {
    this.props.history.push('/tehtavalista/uusi-tehtava', {
      subject: this.props.subject,
    })
  }

  render() {
    const { isActionRequired } = this.state
    return (
      <div className={css.requiresAction}>
        <Mutation mutation={upsertMonthlyInfo}>
          {(onMutate) => (
            <FormControl component='fieldset'>
              <RadioGroup
                value={isActionRequired}
                onChange={(e) => this.onChange(onMutate, e.target.value)}
                className={css.formControls}
              >
                <FormControlLabel value='no' control={<Radio />} label={i18n.t('buttons.no')} />
                <FormControlLabel value='yes' control={<Radio />} label={i18n.t('buttons.yes')} />
              </RadioGroup>
            </FormControl>
          )}
        </Mutation>
        {this.props.showCreateTaskButton !== false && isActionRequired === 'yes' && (
          <Button
            className={cx(css.createTaskButton, {
              [css.createTaskButtonVisible]: isActionRequired,
            })}
            color='primary'
            onClick={this.onCreateTask}
          >
            {i18n.t('monthlyInfo.button.createTask')}
          </Button>
        )}
      </div>
    )
  }
}

export default withRouter<RequiresActionProps>(RequiresAction)
